<ng-container *ngIf="isLoading$ | async as loadingStatus">
  <mat-progress-bar class="progress-bar" mode="indeterminate"></mat-progress-bar>
</ng-container>
